import React from 'react';
import { Layout, Col, Row, Card, Collapse, BackTop } from 'antd';
import '../assets/css/help.css';

function callback(key: any) {
  console.log(key);
}

const text = `
    A dog is a type of domesticated animal.
    Known for its loyalty and faithfulness,
    it can be found as a welcome guest in many households across the world.
  `;

const panelList = [
  {
    key: '1',
    title: 'Wants to chancel order?',
    text:
      'A dog is a type of domesticated animal. Known for its loyalty and faithfulness,it can be found as a welcome guest in many households across the world.'
  },
  { key: '2', title: 'Want a invoice for the order?', text: '' },
  { key: '3', title: 'Can I order from other location?', text: '' },
  { key: '4', title: 'I want my refund back?', text: '' },
  { key: '5', title: 'What is maximum delivery time?', text: '' },
  { key: '6', title: 'How can I contact customer care?', text: '' }
];

const HelpPage: React.FC = (props: any) => {
  const { Content } = Layout;
  const { Panel } = Collapse;

  return (
    <div>
      <Layout>
        <Content className="site-layout">
          <Row>
            <Col span={24}>
              <Card title="FAQs" className="help-main-card">
                <Collapse defaultActiveKey={['1']} onChange={callback}>
                  {panelList.map((item) => (
                    <Panel header={item.title} key={item.key}>
                      <p>{text}</p>
                    </Panel>
                  ))}
                </Collapse>
              </Card>
            </Col>
          </Row>
          <BackTop />
        </Content>
      </Layout>
    </div>
  );
};

export default HelpPage;
